import { useEffect } from 'react';
import { apiRolesToRolesAssignment } from 'modules/account/detail/helpers/accountDetailHandlers';
import type { RolesToAssign } from 'modules/account/types';
import type { ReplaceRoles, ReplaceUserAuthen } from 'modules/account/types';
import type { ReplaceUserRoles } from 'modules/account/types';

interface UseRolesSyncParams {
  accountRoles: ReplaceUserRoles | null | undefined;
  availableRoles: ReplaceRoles | undefined;
  userAuthen: ReplaceUserAuthen | null | undefined;
  setRolesToAssign: React.Dispatch<React.SetStateAction<RolesToAssign>>;
}

/**
 * Đồng bộ accountRoles (GET /management/user/:userId/role) vào rolesToAssign.
 * Dùng apiRolesToRolesAssignment để transform 1 lần theo ReplaceUserRoles.
 */
export function useRolesSync(params: UseRolesSyncParams): void {
  const { accountRoles, availableRoles, userAuthen, setRolesToAssign } = params;

  useEffect(() => {
    if (!accountRoles || !availableRoles) return;

    const rolesAssignment = apiRolesToRolesAssignment(accountRoles);
    if (!rolesAssignment) return;

    const isClient = userAuthen?.userActualManagingOrgType === 'client';
    const rawClients =
      (isClient
        ? (availableRoles.clientsForClientRoles ?? availableRoles.allClients)
        : availableRoles.allClients) ?? [];
    const customersSource = rawClients;

    setRolesToAssign({
      customersSource,
      allRoles: availableRoles,
      rolesAssignment,
    });
  }, [accountRoles, availableRoles, userAuthen, setRolesToAssign]);
}
